<template>
  <PapeleriaElistmentForm :typeEndPoint="'papeleriaElistmentForm'" :dataParams="{}"/>
</template>
<script>
import PapeleriaElistmentForm from '@/components/modules/papeleria/enlistment/form'
export default {
  name: 'PapeleriaElistmentCreate',
  components: {
    PapeleriaElistmentForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/enlistment/create.vue